module.exports = " <div> {{{line.conteudo}}} </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/semtable/conteudotexto.vue
// module id = 187
// module chunks = 0